import type { TFunction } from 'i18next';

/** チャージイベントの purpose からメモ部分を取り出す（レガシー「チャージ（note）」にも対応） */
export function extractChargeNote(purpose: string | null | undefined): string {
  const p = (purpose ?? '').trim();
  if (!p || p === 'チャージ') return '';
  const legacy = p.match(/^チャージ[（(](.+)[）)]$/);
  if (legacy) return legacy[1].trim();
  return p;
}

/** イベント一覧・履歴での用務（purpose）表示。空は呼び出し側でプレースホルダを出さない */
export function displayTppPurpose(
  eventKind: string,
  purpose: string | null | undefined,
  _translate: TFunction
): string {
  if (eventKind === 'charge') {
    // 種別列が「チャージ」なので、用務列はメモだけ
    return extractChargeNote(purpose);
  }
  return purpose?.trim() ? purpose : '';
}
